import { render } from "./BlockItemShadow.vue?vue&type=template&id=6952bfea&scoped=true&ts=true"
import script from "./BlockItemShadow.vue?vue&type=script&lang=ts"
export * from "./BlockItemShadow.vue?vue&type=script&lang=ts"

import "./BlockItemShadow.vue?vue&type=style&index=0&id=6952bfea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6952bfea"]])

export default __exports__